import React from 'react';
import { CircularProgress } from '../CircularProgress';

interface MacroRingsProps {
  protein: { current: number; goal: number };
  carbs: { current: number; goal: number };
  fat: { current: number; goal: number };
}

export function MacroRings({ protein, carbs, fat }: MacroRingsProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="text-center">
        <div className="relative w-24 h-24 mx-auto">
          <CircularProgress
            value={(protein.current / protein.goal) * 100}
            maxValue={100}
            size={96}
            strokeWidth={8}
            color="orange"
            label="Protein"
            centerContent={
              <div className="text-center">
                <div className="text-lg font-bold">{protein.current}</div>
                <div className="text-xs text-muted-foreground">g</div>
              </div>
            }
          />
        </div>
        <div className="mt-2 text-sm">Protein</div>
      </div>

      <div className="text-center">
        <div className="relative w-24 h-24 mx-auto">
          <CircularProgress
            value={(carbs.current / carbs.goal) * 100}
            maxValue={100}
            size={96}
            strokeWidth={8}
            color="cyan"
            label="Carbs"
            centerContent={
              <div className="text-center">
                <div className="text-lg font-bold">{carbs.current}</div>
                <div className="text-xs text-muted-foreground">g</div>
              </div>
            }
          />
        </div>
        <div className="mt-2 text-sm">Carbs</div>
      </div>

      <div className="text-center">
        <div className="relative w-24 h-24 mx-auto">
          <CircularProgress
            value={(fat.current / fat.goal) * 100}
            maxValue={100}
            size={96}
            strokeWidth={8}
            color="purple"
            label="Fat"
            centerContent={
              <div className="text-center">
                <div className="text-lg font-bold">{fat.current}</div>
                <div className="text-xs text-muted-foreground">g</div>
              </div>
            }
          />
        </div>
        <div className="mt-2 text-sm">Fats</div>
      </div>
    </div>
  );
}